import { ProgressBarColor, ProgressBarHeight, ProgressBarThresholdIndicatorColor } from '../enums';
import { Magnetic as Mi } from '../../../styles';
export const getProgressBarColor = (progressColor) => {
    switch (progressColor) {
        case ProgressBarColor.RED:
            return Mi.colorRed;
        case ProgressBarColor.BLUE:
            return Mi.colorBrand40;
        case ProgressBarColor.GREEN:
            return Mi.colorGreen05;
        case ProgressBarColor.ORANGE:
            return Mi.colorOrange;
    }
};
export const getProgressBarHeight = (height, isProgressPercentageDisplayed) => {
    if (height === ProgressBarHeight.LARGE || isProgressPercentageDisplayed)
        return 12;
    return 6;
};
export const getProgressBarThresholdFontSize = (height, isProgressPercentageDisplayed) => {
    return getProgressBarHeight(height, isProgressPercentageDisplayed);
};
export const getProgressBarThresholdMarginTop = (height, isProgressPercentageDisplayed) => {
    const multiplier = isProgressPercentageDisplayed ? 3.5 : 2;
    return getProgressBarHeight(height, isProgressPercentageDisplayed) * -multiplier;
};
export const getValidProgress = (progress) => {
    if (progress > 100) {
        return 100;
    }
    if (progress < 0) {
        return 0;
    }
    return progress;
};
export const getThredsholdIndicatorColor = (color) => {
    switch (color) {
        case ProgressBarThresholdIndicatorColor.LIGHT:
            return Mi.colorNeutral30;
        case ProgressBarThresholdIndicatorColor.DARK:
        default:
            return Mi.colorNeutral80;
    }
};
export const getThresholdIndicatorMarginLeft = (height, isProgressPercentageDisplayed, thresholdIndicator) => {
    if (thresholdIndicator === 100) {
        return `-${Mi.spacer04}`;
    }
    else {
        if (height === ProgressBarHeight.LARGE || isProgressPercentageDisplayed)
            return `-${Mi.spacer06}`;
        return `-${Mi.spacer04}`;
    }
};
export const getProgressBarThresholdMarginRight = (thresholdIndicator) => {
    if (thresholdIndicator === 100)
        return `-${Mi.spacer16}`;
    return '';
};
//# sourceMappingURL=ProgressBarOperations.js.map